module.exports = "<sx-listado-desplegable [fuente]=\"grupos\" [tipo]=\"'PAYMENT_GATEWAY' | translate\">\r\n</sx-listado-desplegable>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/paymentGateway/configurar.paymentGateway.component.html
// module id = ../../../../../src/app/private/configuracion/paymentGateway/configurar.paymentGateway.component.html
// module chunks = main